import { Component, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SafeResourceUrl } from '@angular/platform-browser';
import { fromEvent } from 'rxjs';
import { filter, map } from 'rxjs/operators';

interface Msg {
    type: string;
    data: any;
}

@Component({
    selector: 'app-belender-widget',
    standalone: true,
    imports: [],
    templateUrl: './belender-widget.component.html',
    styleUrls: ['./belender-widget.component.scss']
})
export class BelenderWidgetComponent {
    readonly url = input.required<string | SafeResourceUrl>();   // must be consent url, not consent url boxed

    protected readonly height = toSignal(
        fromEvent<MessageEvent>(window, 'message').pipe(
            map(event => event.data as Msg),
            filter(msg => msg.type === 'widgetHeight'),
            map(msg => msg.data as number)
        ),
        { initialValue: 0 }
    );
}
